import React from 'react';
import { ShieldCheckIcon, AwardIcon, BadgeCheckIcon } from 'lucide-react';
export function TrustBar() {
  return <section className="bg-tlfc-cream py-12 border-b border-tlfc-border" data-id="element-494">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10" data-id="element-495">
        <p className="reveal text-center text-sm text-tlfc-muted" data-id="element-496">
          Trusted by clients. Recognised by industry.
        </p>

        <div className="reveal reveal-delay-1 mt-8 flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16" data-id="element-497">
          {/* Doyle's Guide */}
          <div className="flex items-center gap-3" data-id="element-498">
            <div className="w-10 h-10 rounded-full bg-tlfc-gold/10 flex items-center justify-center" data-id="element-499">
              <ShieldCheckIcon className="w-5 h-5 text-tlfc-gold" aria-hidden="true" data-id="element-500" />
            </div>
            <div data-id="element-501">
              <p className="font-medium text-tlfc-text text-sm" data-id="element-502">
                Doyle's Guide
              </p>
              <p className="text-xs text-tlfc-text-secondary" data-id="element-503">
                Recognised for excellence
              </p>
            </div>
          </div>

          {/* Best Law Firms */}
          <div className="flex items-center gap-3" data-id="element-504">
            <div className="w-10 h-10 rounded-full bg-tlfc-gold/10 flex items-center justify-center" data-id="element-505">
              <AwardIcon className="w-5 h-5 text-tlfc-gold" aria-hidden="true" data-id="element-506" />
            </div>
            <div data-id="element-507">
              <p className="font-medium text-tlfc-text text-sm" data-id="element-508">
                Best Law Firms – Australia
              </p>
              <p className="text-xs text-tlfc-text-secondary" data-id="element-509">
                Named among leading firms
              </p>
            </div>
          </div>

          {/* Accredited Specialists */}
          <div className="flex items-center gap-3" data-id="element-510">
            <div className="w-10 h-10 rounded-full bg-tlfc-gold/10 flex items-center justify-center" data-id="element-511">
              <BadgeCheckIcon className="w-5 h-5 text-tlfc-gold" aria-hidden="true" data-id="element-512" />
            </div>
            <div data-id="element-513">
              <p className="font-medium text-tlfc-text text-sm" data-id="element-514">
                Accredited Specialists
              </p>
              <p className="text-xs text-tlfc-text-secondary" data-id="element-515">
                LIV certified specialists
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}